export default function isAuthorized(userRole, requiredRole) {
	if (userRole === 'owner' || requiredRole === 'user') {
		return true;
	} else if (userRole === 'admin' && requiredRole === 'admin') {
		return true;
	}
	console.log('The user is not authorized');
	return false;
}
